export const environment = {
  production: false,
  development: false,
  test: true,
  brand: 'Vyv',
  apiRootUrl: 'https://vyvfrtstmrhapi001.azurewebsites.net',
  frontUrl: '__FrontUrl__',
  matomotoKey: '__MatomotoKey__',
  appInsightsKey: '6dd74c8d-265b-47a9-84ea-8da58c6df70f',
  assConfort:
    'https://vyvfrtstmrhst001.blob.core.windows.net/public/documents/220830_VYV_TG_ASS_HAB_CONFORT.pdf',
  assParisienne:
    'https://vyvfrtstmrhst001.blob.core.windows.net/public/documents/230830_VYV_TG_ASS_HAB_PARISIENNE.pdf',
  assSolidaire:
    'https://vyvfrtstmrhst001.blob.core.windows.net/public/documents/230830_VYV_TG_ASS_HAB_SOLIDAIRE.pdf',
  wcbMRH_S: 'https://wcb-preprod.assurone.com/VyVConseilMrhSolidaire',
  wcbMRH_C: 'https://wcb-preprod.assurone.com/VyVConseilMrh',
  matomoHostUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/',
  matomoSiteId: 6,
  matomoScriptUrl:
    'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/js/container_682wvypB.js',
  modeleCourrierResiliation:
    'https://vyvfrtstmrhst001.blob.core.windows.net/public/documents/ModeleCourrier.docx'
};
